export const calcPositionFromSegmentsLength = (apiClient) => {
    return {
        build(params) {
            return apiClient.request('/standard/calcPositionFromSegmentsLength', params);
        },
    };
};
